import type { Middleware, Dispatch, AnyAction } from 'redux';
import type { Action, Logger } from 'people/lib/shared';
import type { ThunkAction } from 'redux-thunk';

type NewAction = Action<{}> | ThunkAction<{}, {}, {}, AnyAction>;

function logAction(logger: Logger, action: Action<{}>): void {
    if (action.getLogProperties) {
        const logName = action.error ? action.type + '_Error' : action.type;
        logger.log(logName, action.getLogProperties(action));
    }
}

export function createActionLogger(logger: Logger): Middleware {
    const owaLogger = () => (next: Dispatch) => (action: NewAction) => {
        // action will never be of type ThunkAction, but required to get compilation to work.
        logAction(logger, action as Action<{}>);
        return next(action as Action<{}>);
    };

    return owaLogger as Middleware;
}
